import React from 'react';
import '../styles/Toggle.scss';

export default function Toggle({ className, checked, onChange, highlight, ...rest }) {

    return (
        <label className={`toggle-switch ${highlight ? 'highlight' : ''}`}>
            <input type="checkbox" className={className} onChange={(e) => onChange(e.target.checked)} checked={checked} {...rest} />
            <span className={`slider ${ (className) && className }`}></span>
        </label>
    )
}